import auth from "./auth";
import user from "./user";
import statics from "./statics";
import enrollment from "./enrollment";
import course from "./course";
import file from "./file";
import certification from "./certification";
import quiz from "./quiz";

const services = {
  auth,
  user,
  statics,
  enrollment,
  course,
  file,
  certification,
  quiz,
};

export default services;
